import { index, Options } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;
  z-index: ${index(Options.ONBOARDING_OVERLAY)};

  width: 100%;
  height: 100dvh;
  padding: ${({ theme }) => theme.spacing(4)};

  background-color: ${({ theme }) => theme.palette.background.default};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(5)};

  width: 100%;
  max-width: 34.4rem;
`;

export const AppIcon = styled.img`
  width: 9.6rem;
  height: 9.6rem;
`;

export const UspList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};

  width: 100%;
  margin: 0;
  padding: ${({ theme }) => `0 ${theme.spacing(4)}`};

  list-style: none;
`;

export const UspItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const UspIcon = styled.span`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 2rem;
  height: 2rem;

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const UspText = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};

  width: 100%;
`;
